if ($('.foo2').length > 0) {
  $('.foo2').carouFredSel({
    scroll: 1,
    responsive: true,
    items: {
      width: 370,
      height: 'variable',
      visible: {
        min: 1,
        max: 2,
      },
    },
    swipe: {
      onTouch: true,
      onMouse: false,
    },
    prev: {
      button: $('.prevSlide'),
    },
    next: {
      button: $('.nextSlide'),
    },
    pagination: '.foo2_pag',
    circular: true,
    infinite: true,
    auto: true,
  });
}

function listStatic() {
  if ($(window).innerWidth() < 480) {
    $('.foo2').trigger('pause', true);
  } else {
    $('.foo2').trigger('play', true);
  }
}

listStatic();

// loads more for mobile promos
function loadMore() {
  if ($(window).innerWidth() < 480) {
    $('.doubleSlide ul li').slice(0, 3).show();
    $('.loadProducts').click((e) => {
      e.preventDefault();
      $('.doubleSlide ul li:hidden').slice(0, 3).show();
      if ($('.doubleSlide ul li:hidden').length === 0) {
        $('.loadProducts').hide();
      }
    });
  }
}

loadMore();

$(window).resize(() => {
  listStatic();
  loadMore();
});
